// Textos en español del SDK de captura. Mismas claves que `en.ts` (lo exige una prueba).
export const es = {
  'app.title': 'Captura KYP',
  'app.close': 'Cerrar',
  'app.error': 'Algo ha fallado. Inténtalo de nuevo.',
  'app.retry': 'Reintentar',
  'app.next': 'Continuar',
  'app.skip': 'Omitir',
  'app.loading': 'Un momento…',
  'step.permission': 'Cámara',
  'step.label': 'Etiqueta',
  'step.challenge': 'Reto en directo',
  'step.views': 'Vistas',
  'step.ruler': 'Medidas',
  'step.declarations': 'Datos',
  'step.summary': 'Resumen',
  'step.progress': 'Paso {n} de {total}: {name}',
  'permission.title': 'Vamos a fotografiar tu paquete',
  'permission.body':
    'Usaremos la cámara en directo. No se pueden subir fotos ya hechas: así garantizamos que el paquete está delante de ti ahora.',
  'permission.button': 'Permitir la cámara',
  'permission.checking': 'Comprobando la cámara…',
  'rejected.title': 'No podemos empezar la captura',
  'rejected.virtual_camera':
    'La cámara parece virtual o de software. Usa la cámara real del dispositivo.',
  'rejected.settings_incoherent':
    'La cámara informa de una configuración extraña. Prueba con otra cámara o con otro navegador.',
  'rejected.getusermedia_patched':
    'El acceso a la cámara ha sido modificado por una extensión o un script. Desactívalo y vuelve a intentarlo.',
  'rejected.flat_frame':
    'La imagen está completamente plana. Destapa la cámara y vuelve a intentarlo.',
  'rejected.no_sensor_noise':
    'La imagen no parece venir de un sensor real. Usa la cámara del dispositivo.',
  'rejected.no_frames': 'No llegan imágenes de la cámara. Vuelve a intentarlo.',
  'rejected.no_camera': 'No hemos encontrado ninguna cámara en este dispositivo.',
  'rejected.permission_denied':
    'Sin permiso de cámara no podemos continuar. Puedes darlo en los ajustes del navegador.',
  'rejected.unsupported':
    'Este navegador no permite la captura en directo. Prueba con otro navegador.',
  'rejected.server': 'El servidor no ha aceptado la sesión de captura.',
  'label.title': 'Etiqueta del envío',
  'label.body': 'Encuadra la etiqueta dentro del marco y pulsa el botón.',
  'label.detected': 'Código detectado: {code}',
  'label.tracking': 'Número de seguimiento',
  'label.shoot': 'Fotografiar la etiqueta',
  'challenge.title': 'Reto en directo',
  'challenge.body':
    'La pantalla cambiará de color unos segundos. Apunta al paquete y gira despacio a su alrededor.',
  'challenge.start': 'Empezar el reto',
  'challenge.running': 'Gira despacio alrededor del paquete',
  'challenge.done': 'Reto grabado',
  'views.title': 'Vista {n} de {total}: {name}',
  'views.front': 'frontal',
  'views.side': 'lateral',
  'views.top': 'superior',
  'views.label_corner': 'esquina con la etiqueta',
  'views.hint.front': 'Ponte delante del paquete y que se vea entero.',
  'views.hint.side': 'Ahora uno de los lados, entero dentro del marco.',
  'views.hint.top': 'Desde arriba, con la cara superior entera.',
  'views.hint.label_corner': 'La esquina donde está la etiqueta, con la etiqueta visible.',
  'views.shoot': 'Fotografiar',
  'views.shooting': 'Capturando…',
  'quality.dark': 'La foto ha salido oscura.',
  'quality.blurry': 'La foto parece movida.',
  'quality.retry': 'Repetir',
  'quality.keep': 'Usar igualmente',
  'quality.ok': 'Foto guardada.',
  'ruler.title': 'Medidas (opcional)',
  'ruler.body':
    'Si imprimes la regla KYP y la pones junto al paquete, podemos estimar sus medidas. Las medidas que indiques se guardan como estimadas.',
  'ruler.link': 'Abrir la regla KYP (A4)',
  'ruler.estimated': 'Medidas estimadas',
  'ruler.length': 'Largo',
  'ruler.width': 'Ancho',
  'ruler.height': 'Alto',
  'ruler.unit': 'Unidad',
  'declarations.title': 'Lo que declaras',
  'declarations.body': 'Opcional. Se guarda como declaración tuya, nunca como medida comprobada.',
  'declarations.weight': 'Peso (gramos)',
  'declarations.content': 'Contenido',
  'declarations.tracking': 'Número de seguimiento',
  'summary.title': 'Resumen',
  'summary.body': 'Firmaremos la captura en este dispositivo y la enviaremos.',
  'summary.shots': 'Fotos: {n}',
  'summary.video': 'Vídeo del reto: {n} trozos',
  'summary.submit': 'Firmar y enviar',
  'summary.uploading': 'Subiendo {done} de {total}',
  'summary.stage.received': 'Recibido',
  'summary.stage.signed': 'Firmado',
  'summary.stage.sealed': 'Sellado',
  'result.title': 'Captura enviada',
  'result.level': 'Nivel de confianza: {level}',
  'result.level.attested': 'atestado',
  'result.level.signed': 'firmado',
  'result.level.degraded': 'degradado',
  'result.level.rejected': 'rechazado',
  'result.score': 'Puntuación: {score}/100',
  'result.peid': 'Identificador del paquete: {peid}',
  'result.verify': 'Ver el documento del paquete',
  'result.findings': 'Observaciones: {n}',
  'handoff.title': 'Sigue en el móvil',
  'handoff.body': 'Escanea el código QR con el móvil o abre el enlace y escribe el código.',
  'handoff.code': 'Código: {code}',
  'handoff.link': 'Enlace para el móvil',
  'handoff.waiting': 'Esperando al móvil…',
  'handoff.opened': 'El móvil ha abierto la captura.',
  'handoff.expired': 'El código ha caducado. Vuelve a empezar.',
  'shutter.label': 'Disparar (Espacio o Intro)',
  'voice.on': 'Guía por voz activada',
} as const;

export type MessageKey = keyof typeof es;
